import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Pulse from "@/pages/Pulse";
import SalesforceMock from "@/pages/SalesforceMock";
import PopupView from "@/pages/PopupView";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/pulse" element={<Pulse />} />
                    <Route path="/salesforce" element={<SalesforceMock />} />
                    <Route path="/salesforce/:accountId" element={<SalesforceMock />} />
                    <Route path="/popup" element={<PopupView />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    classNames: {
                        toast: "!bg-black/80 !border !border-white/10 !text-white",
                    },
                }}
            />
        </div>
    );
}

export default App;
